import { useDispatch } from "react-redux";
import {
  BackButton,
  Button,
  ErrorMark,
  LoadingIndicator,
  NavigationLinkButton
} from "../../../components/RegularComponents";
import { useEffect, useState } from "react";
import { fetchApplicationWithId } from "../../../redux/slice/bltHomeSlice";
import { titleStringFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import {
  APPLICATION_STATUS_WITHDRAWN_APPROVED,
  LICENCE_STATUS_WITHDRAWN
} from "../../../app/constants";
import { postApplicationPayload } from "../../../redux/slice/businessLicenceApplicationSlice";

const LicenceUpgradeWithdrawConfirmation = (props) => {
  const dispatch = useDispatch();
  const [existingBrokerApplication, setExistingBrokerApplication] = useState(null);
  const [loadingIndicator, setLoadingIndicator] = useState(false);
  const [noActiveLicenceFoundError, setNoActiveLicenceFoundError] = useState();
  const [cancellationError, setCancellationError] = useState(false);
  const [yesActionSpinner, setYesActionSpinner] = useState(false);

  useEffect(() => {
    if (!props.licenceUpgradeApplicationId) {
      return;
    }

    setLoadingIndicator(true);
    dispatch(fetchApplicationWithId(props.licenceUpgradeApplicationId, true))
      .then((application) => {
        if (application) {
          setExistingBrokerApplication(application);
        } else {
          setNoActiveLicenceFoundError(true);
        }
      })
      .finally(() => {
        setLoadingIndicator(false);
      });
  }, [props.licenceUpgradeApplicationId, dispatch]);

  const handleYes = () => {
    if (!existingBrokerApplication) {
      console.log("No application");
      return;
    }
    setYesActionSpinner(true);
    //On Yes,need proceed for cancel old and approve new
    const oldApplication = {
      ...existingBrokerApplication,
      applicationStatus: APPLICATION_STATUS_WITHDRAWN_APPROVED,
      licenceStatus: LICENCE_STATUS_WITHDRAWN,
      endDate: Date.now(),
      changeType: "SAVE"
    };
    //Cancel and continue

    dispatch(postApplicationPayload(oldApplication))
      .then(() => {
        setYesActionSpinner(false);
        props.bltReviewHandleContinue();
      })
      .catch(() => {
        //For local testing
        if (window.location.hostname === "localhost") {
          props.bltReviewHandleContinue();
          return;
        }
        setYesActionSpinner(false);
        setCancellationError(true);
      });
  };

  const onCancel = () => {
    //On cancel, create the licence without making any change.
    if (props.onCancel) {
      props.onCancel();
    }
  };

  const onBackClick = () => {
    if (props.onBack) {
      props.onBack();
    }
  };

  return (
    <div className="container">
      <div className="row topMarginNormal">
        <div className="col-3">
          <BackButton title="Back" onClick={onBackClick} />
        </div>
      </div>
      <div className="row bottomMarginMedium">
        <div className="col-lg-12">
          <h2>{"Current licence will be cancelled"}</h2>
        </div>
      </div>
      <LoadingIndicator isLoading={loadingIndicator} />
      {existingBrokerApplication && (
        <div>
          The current{" "}
          <b>{titleStringFromLicenceSubType(existingBrokerApplication.licencingSubType)}</b> for{" "}
          <b>{existingBrokerApplication.contactName}</b> at <b>{existingBrokerApplication.name}</b>{" "}
          will be cancelled and the new licence will become active.
        </div>
      )}

      {noActiveLicenceFoundError && (
        <div className="ns-error-message field-validation-error">
          {ErrorMark()} No active Licence found for this upgrade.
        </div>
      )}
      {cancellationError && (
        <div className="ns-error-message field-validation-error">
          {ErrorMark()} Unbale to cancel the old application.
        </div>
      )}

      <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
        <div style={{ marginRight: "30px" }}>
          <Button
            showSpinner={yesActionSpinner}
            className={"btn btn-primary btn-lg"}
            buttonType={"regular_primary"}
            text={"Yes, make the change"}
            onClick={handleYes}
          />
        </div>
        <div style={{ marginRight: "30px" }}>
          <NavigationLinkButton
            id="licence-withdraw-cancel-button"
            text="Cancel"
            onClick={onCancel}
          />
        </div>
      </div>
    </div>
  );
};

export default LicenceUpgradeWithdrawConfirmation;
